import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Calculator, TrendingUp, CheckSquare, Users, MapPin, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

export const ToolsTeaser = () => {
  const tools = [
    {
      icon: TrendingUp,
      title: 'Live-Marktpreisrechner',
      description: 'Erhalten Sie in 60 Sekunden eine realistische Einschätzung des Marktwerts Ihrer Handelsimmobilie.',
      link: '/tools/marktpreis',
      badge: 'NEU',
      highlight: true,
    },
    {
      icon: Calculator,
      title: 'WAULT Rechner',
      description: 'Berechnen Sie kostenlos den Weighted Average Unexpired Lease Term Ihrer Immobilie.',
      link: '/tools/wault',
      badge: 'Kostenlos',
    },
    {
      icon: CheckSquare,
      title: 'Verkaufs-Readiness Check',
      description: 'Prüfen Sie, ob Ihre Immobilie verkaufsbereit ist und welche Schritte noch notwendig sind.',
      link: '/tools/readiness',
      badge: 'Kostenlos',
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-[#EFF6FF]" data-testid="tools-teaser-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block">
            <div className="w-16 h-1 bg-gradient-to-r from-[#D4A853] to-[#F0C870] mb-4 mx-auto"></div>
          </div>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4"
            style={{ color: 'var(--navy-900)' }}
          >
            Kostenlose Tools für Eigentümer
          </h2>
          <p className="text-lg max-w-2xl mx-auto" style={{ color: 'var(--gray-600)' }}>
            Professionelle Analyse-Tools zur Erstbewertung Ihrer Handelsimmobilie
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {tools.map((tool, index) => {
            const IconComponent = tool.icon;
            return (
              <Card
                key={index}
                className={`glass-card p-8 hover:scale-105 hover:shadow-2xl transition-all duration-300 ${
                  tool.highlight ? 'border-t-4' : ''
                }`}
                style={tool.highlight ? { borderTopColor: 'var(--gold-600)' } : {}}
                data-testid={`tool-card-${index}`}
              >
                <div className="flex items-start justify-between mb-6">
                  <div
                    className="w-16 h-16 rounded-xl flex items-center justify-center shadow-lg"
                    style={{
                      background: tool.highlight 
                        ? 'linear-gradient(135deg, #D4A853 0%, #F0C870 100%)'
                        : 'var(--navy-100)'
                    }}
                  >
                    <IconComponent
                      className="h-8 w-8"
                      style={{ color: tool.highlight ? 'white' : 'var(--navy-600)' }}
                    />
                  </div>
                  {tool.highlight && (
                    <div className="flex items-center gap-1">
                      <Sparkles className="h-4 w-4" style={{ color: 'var(--gold-600)' }} />
                      <span
                        className="text-xs font-bold"
                        style={{ color: 'var(--gold-600)' }}
                      >
                        Beliebt
                      </span>
                    </div>
                  )}
                  {!tool.highlight && (
                    <span
                      className="text-xs font-semibold px-3 py-1 rounded-full"
                      style={{
                        backgroundColor: 'var(--success-100)',
                        color: 'var(--success-600)',
                      }}
                    >
                      {tool.badge}
                    </span>
                  )}
                </div>
                <h3
                  className="text-xl font-bold mb-3"
                  style={{ color: 'var(--navy-800)' }}
                >
                  {tool.title}
                </h3>
                <p className="text-sm mb-6 leading-relaxed" style={{ color: 'var(--gray-600)' }}>
                  {tool.description}
                </p>
                <Link to={tool.link}>
                  <Button
                    variant={tool.highlight ? 'default' : 'outline'}
                    className={`w-full font-semibold ${
                      tool.highlight ? 'btn-gold-gradient text-white border-0' : ''
                    }`}
                    data-testid={`tool-start-button-${index}`}
                    style={!tool.highlight ? {
                      borderColor: 'var(--navy-600)',
                      color: 'var(--navy-600)',
                    } : {}}
                  >
                    Tool starten
                  </Button>
                </Link>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};